import './SendOrderToCustomerModal.scss';

import { any, bool, func, object } from 'prop-types';
import React from 'react';

import ModalComponent from '@components/Share/ModalComponent';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const SendOrderToCustomerModal = (props) => {
  const { isShow, onCloseHandler, onLayoutData, onHandleSave, onSetInputEnter, onInputEnter, typeEvent } = props;

  const handleChange = (evt)=> {
    evt.preventDefault();
    onSetInputEnter(evt.target.value)
  };

  return (
    <ModalComponent isShow={isShow} onCloseHandler={onCloseHandler} titlePopup={''}>
      <div className='send-order-customer-modal'>
        <div className='form-group send-order-customer-modal__input'>
          {typeEvent?.category === onLayoutData?.Email.value ? (
            <>
              <input
                id='enterEmail'
                className={'form-control'}
                name='enterEmail'
                type='text'
                onChange={handleChange}
                value={onInputEnter}
                placeholder={onLayoutData?.['Enter email']?.value}
              />
              <label htmlFor='enterEmail' className='form-group__label'>
                <Text field={onLayoutData?.['Enter email']} />
              </label>
              {typeEvent?.error && (
                <span className='error-validate'>
                  <Text field={onLayoutData?.['Invalid email']} />
                </span>
              )}
            </>
          ) : (
            <>
              <input
                id='enterSMS'
                className={'form-control'}
                name='enterSMS'
                type='text'
                onChange={handleChange}
                value={onInputEnter}
                placeholder={onLayoutData?.['Enter sms']?.value}
              />
              <label htmlFor='enterSMS' className='form-group__label'>
                <Text field={onLayoutData?.['Enter sms']} />
              </label>
              {typeEvent?.error && (
                <span className='error-validate'>
                  <Text field={onLayoutData?.['Invalid sms']} />
                </span>
              )}
            </>
          )}
        </div>
        <div className='send-order-customer-modal__btn'>
          <button className='btn btn-primary btn-save' onClick={onHandleSave}>
            <Text field={onLayoutData?.Save}/>
          </button>
        </div>
        <div className='send-order-customer-modal__btn'>
          <button className='btn-link btn-cancel' onClick={onCloseHandler}>
            <Text field={onLayoutData?.Cancel}/>
          </button>
        </div>
      </div>
    </ModalComponent>
  );
};

SendOrderToCustomerModal.propTypes = {
  isShow: bool,
  onCloseHandler: func,
  onLayoutData: object,
  onHandleSave: any,
  onSetInputEnter: any,
  onInputEnter: any,
  typeEvent: object
};

export default SendOrderToCustomerModal;
